import { withJsonFormsControlProps } from '@jsonforms/react';
import { Image } from './Image';

const ImageControl = ({ data, handleChange, path, schema, visible }) => {
  return (
    <Image
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      image={schema?.image ?? ''}
      visible={visible}
    />
  );
};

export default withJsonFormsControlProps(ImageControl);
